import React, { useState, useEffect } from "react";
import ImageCarousel from "./ImageCarousel";

const Renders = ({
  show,
  t,
  scrollToNextSection,
  setIsRenderOpen,
  validImages,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => setIsVisible(true), 80);
      return () => clearTimeout(timer);
    }
  }, [show]);

  return (
    <div
      className={`fade-in-section relative text-center ${
        isVisible ? "show" : ""
      }`}
    >
      <h1 className="header text-2xl md:text-4xl text-black tracking-widest uppercase">
        {t("section6.header")}
      </h1>
      <div className="section-entry">
        <p className="text-p-s px-0 pt-10 pb-12 md:px-8">
          {t("section6.description")}
        </p>
      </div>

      {/* <Link to="/start-your-project" reloadDocument className="btn rounded-bl-xl rounded-tr-xl" id='renders'>
        ENQUIRE NOW
      </Link> */}

      <div className="carousel-full-screen" id="renders">
        <ImageCarousel images={validImages} slideCount={1}>
          {validImages.map((image, index) => (
            <div key={index} className="flex-center" onClick={setIsRenderOpen}>
              <img
                src={`/images/renders/${image}`}
                alt={`Slide ${image}`}
                className="w-full h-auto"
                loading="lazy"
              />
            </div>
          ))}
        </ImageCarousel>
        <div className="scroll" onClick={() => scrollToNextSection("ownApp")}>
          <img
            src="/icons/down-arrow.svg"
            alt="Down Arrow"
            height={40}
            className="arrow-down"
          />
        </div>
        <div className="intro cinematic-intro">
          <div
            className="flex-row-center mt-32 mb-6 cursor-pointer"
            onClick={() => setIsRenderOpen(true)}
          >
            <img src="/icons/playbtn.svg" className="mr-2 playbtn" alt="" />
            <p className="border-white border-b-2 intro_title uppercase">
              {t("section6.mediaTitle")}
            </p>
          </div>
        </div>
        <p className="text-p-m mt-3 uppercase">{t("section6.label")}</p>
      </div>
    </div>
  );
};

export default Renders;
